'use client'
import { useEffect } from 'react'

import { VERSION_CHECK_INTERVAL_MS } from '@/constants'
import { showInformation } from '@/utils/toast'
import { trpc } from '@/utils/trpc'

export default function VersionCheck({
  initialBuildId,
}: {
  initialBuildId: string
}) {
  const { data: currentBuildCommitSha } = trpc.version.getVersion.useQuery(
    undefined,
    {
      refetchInterval: VERSION_CHECK_INTERVAL_MS,
      refetchOnWindowFocus: true,
      staleTime: 0,
    },
  )

  useEffect(() => {
    if (
      initialBuildId &&
      currentBuildCommitSha &&
      initialBuildId !== currentBuildCommitSha
    ) {
      showInformation('New version available', {
        description: 'A new version has been deployed. Refresh to update.',
        duration: 24 * 60 * 60 * 1000, // 24 hours
      })
    }
  }, [currentBuildCommitSha, initialBuildId])
  return null
}
